import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Toolbar, Typography, Tooltip, IconButton, InputBase, List, ListItem, Box, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Button, Chip, Menu, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './index.style';
import { getLoadFilter, getLoads, updateLoadFilter } from 'redux/actions/Loads';
import { Edit, Filter } from '@material-ui/icons';
import { Search } from '@material-ui/icons';
// import LoadSearch from '../LoadSearch';

const filterOptionsList = [
  { label: 'Active', value: 'active' },
  { label: 'Suspended', value: 'suspended' },
];

const LoadTableToolbar = ({ currentTab, onAddFilter, setFilterOptions, handleSavedSearch, filter = '' }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { currentLoadFilter } = useSelector(({ loadsReducer }) => loadsReducer);
  // const [searchText, setSearchText] = useState('');

  // function handleSearch() {
  //   if (searchText && searchText.length) {
  //     dispatch(getLoads({ unique_load_id: searchText })).then(() => {});
  //   }
  // }

  // function handleClear() {
  //   let updatedFilter = {
  //     ...currentLoadFilter,
  //   };
  //   dispatch(updateLoadFilter(updatedFilter, () => {}));
  //   setSearchText('');
  // }

  // const handleKeyDown = event => {
  //   if (event.key === 'Enter') {
  //     // console.log('enter press here! ');
  //     handleSearch();
  //     if (!searchText && !searchText.length) {
  //       handleClear();
  //     }
  //   }
  // };

  // const onFilterOptionClick = option => {
  //   setFilterOptions(prevState => {
  //     if (prevState.includes(option.value)) {
  //       return prevState.filter(item => item !== option.value);
  //     } else {
  //       return [...prevState, option.value];
  //     }
  //   });
  // };

  // useEffect(() => {
  //   if (currentLoadFilter && currentLoadFilter.unique_load_id) {
  //     setSearchText(currentLoadFilter.unique_load_id);
  //   }
  // }, [currentLoadFilter]);

  return (
    <React.Fragment>
      <Toolbar className={clsx(classes.root)}>
        <Grid container alignItems="center">
          <Grid item xs={10}>
            <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
              Daily Loads{' '}
              {!currentLoadFilter || Object.keys(currentLoadFilter).length < 2 ? (
                <Button className={classes.addFilterButton} color="primary" onClick={() => onAddFilter(true)}>
                  New Search
                </Button>
              ) : (
                <Chip
                  deleteIcon={<Edit fontSize="small" />}
                  className={classes.editFilterChip}
                  variant="outlined"
                  label={`${currentLoadFilter.pickUpValue && currentLoadFilter.pickUpValue.name} -> ${
                    currentLoadFilter.dropOffValue ? currentLoadFilter.dropOffValue.name : 'Anywhere'
                  }`}
                  onDelete={() => onAddFilter(true)}
                  onClick={() => onAddFilter(true)}
                  color="primary"
                />
              )}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            {/* <LoadSearch /> */}
            {filter != '' ? <React.Fragment>{filter()}</React.Fragment> : null}
          </Grid>
        </Grid>
      </Toolbar>
    </React.Fragment>
  );
};

LoadTableToolbar.propTypes = {
  filterOptions: PropTypes.object,
  setFilterOptions: PropTypes.func,
  onAddFilter: PropTypes.func,
};

export default React.memo(LoadTableToolbar);
